import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { SubstanceAliasTranslations } from "../../../Data/Art57Data/SubstanceAliasTranslations";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceAliasTranslations extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new SubstanceAliasTranslations(new FieldDefinition(injector)),
        'Alias Translation'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Alias Translation';
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      let languageCode = '';
      let translation = '';
  
      if (this.data && this.data.model && this.data.model.languagecode) {
        languageCode = this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'language',
          this.data.model.languagecode
        );
      }
  
      if (this.data && this.data.model && this.data.model.term) {
        translation = this.data.model.term;
      }
  
      if (languageCode != '' && translation != '') {
        this.label = languageCode + ' - ' + translation;
      } else if (languageCode != '' || translation != '') {
        this.label = languageCode + translation; // only one of them is filled
      } else {
        this.label = this.labelTemplate;
      }
    }
  
    override getMessage(): any {
      if (this.data.model && Object.keys(this.data.model).length > 0) {
        return this.data.model;
      } else {
        return;
      }
    }
  
     override getListItem(): any[] {
      return [
        this.data.model && this.data.model.languagecode
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'language',
            this.data.model.languagecode
          )
          : 'Not selected',
        this.data.model && this.data.model.term
          ? this.data.model.term
          : 'Not selected',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeSubstanceAliasTranslations =
        new TreeNodeSubstanceAliasTranslations(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.refreshLabel();
  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];
      
      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
  }
  